export default __webpack_public_path__ + "static/media/ci.d281e81a.jpg";